import ol from "openlayers";

const gps = {
  geolocation: null as ol.Geolocation | null,
  overlay: null as ol.Overlay | null,
  accuracyLayer: null as ol.layer.Vector | null,
  init: (map: ol.Map) => {
    if (gps.geolocation) {
      return;
    }

    gps.geolocation = new ol.Geolocation({
      projection: map.getView().getProjection(),
      trackingOptions: {
        enableHighAccuracy: true,
      },
    });

    gps.geolocation.on("change", gps.handlePositionChange.bind(null, map));

    gps.overlay = new ol.Overlay({
      element: document.createElement("div"),
    });
  },
  start: (map: ol.Map) => {
    gps.init(map);

    map.addOverlay(gps.overlay!);
    gps.geolocation!.once("change", gps.centerMap.bind(null, map));
    gps.geolocation!.setTracking(true);
  },
  stop: (map: ol.Map) => {
    gps.geolocation!.setTracking(false);
    map.removeOverlay(gps.overlay!);
    map.removeLayer(gps.accuracyLayer!);
  },
  toggle: (map: ol.Map) => {
    if (gps.geolocation && gps.geolocation.getTracking()) {
      gps.stop(map);
    } else {
      gps.start(map);
    }
  },
  handlePositionChange: (map: ol.Map) => {
    const coord = gps.geolocation!.getPosition();
    const geom = gps.geolocation!.getAccuracyGeometry();
    const heading = gps.geolocation!.getHeading();
    gps.updatePositionOverlay(map, coord, heading);
    gps.updateAccuracyGeom(map, geom);
  },
  updatePositionOverlay: (map: ol.Map, coord: ol.Coordinate, heading: number) => {
    const iconElement = gps.getPositionIconElement(heading);
    const offset = [-8, -9.5];
    gps.overlay!.setPosition(coord);
    gps.overlay!.setOffset(offset);
    gps.overlay!.setElement(iconElement);
  },
  getPositionIconElement: function (heading: number) {
    const element = document.createElement("div");
    const iconClass = heading === undefined ? "fa-circle" : "fa-location-arrow";

    const fontAwsomeIconToNorthRotation = 5.5;
    const adjustedHeading = heading !== undefined ? heading + fontAwsomeIconToNorthRotation : 0;
    const fontSize = 20;
    element.innerHTML =
      '<i class="fa ' +
      iconClass +
      '" style="color: #F116D2; font-size: ' +
      fontSize +
      "px; transform: rotate(" +
      adjustedHeading +
      'rad);"/>';

    return element;
  },
  updateAccuracyGeom: (map: ol.Map, geom: ol.geom.Geometry) => {
    if (gps.accuracyLayer) {
      map.removeLayer(gps.accuracyLayer);
    }
    let feature = new ol.Feature({
      geometry: geom,
    });
    let source = new ol.source.Vector({
      features: [feature],
    });

    gps.accuracyLayer = new ol.layer.Vector({
      source: source,
      style: new ol.style.Style({
        fill: new ol.style.Fill({
          color: "rgba(241, 22, 210, 0.05)",
        }),
        stroke: new ol.style.Stroke({
          color: "rgba(241, 22, 210, 0.5)",
        }),
      }),
    });

    map.addLayer(gps.accuracyLayer);
  },
  centerMap: (map: ol.Map) => {
    const coord = gps.geolocation!.getPosition();
    gps.panToCoord(map, coord);
  },
  panToCoord: function (map: ol.Map, coordinate: ol.Coordinate) {
    let view = map.getView();
    view.animate({
      duration: 300,
      center: view.getCenter(),
    });
    view.setCenter(coordinate);
  },
};

export default gps;
